import { useDispatch, useSelector } from 'react-redux';
import { getTenantLogo, login, logout, reCaptchaVarify } from 'store/auth';

function useAuthStore() {
  const isLoggedIn = useSelector((state) => state.auth.isAuth);
  const user = useSelector((state) => state.auth.data);
  const tenantLogo = useSelector((state) => state.auth?.tenantMeta?.logo);
  const AccessToken = useSelector((state) => state.auth?.tokens?.access);
  const Loginshow = useSelector((state) => state.auth?.show);
  const dispatch = useDispatch();
  const loginAction = (params) => dispatch(login(params));
  const logoutAction = () => dispatch(logout());
  const reCaptchaVarifyAction = (params) => dispatch(reCaptchaVarify(params));
  const getTenantLogoAction = (params) => dispatch(getTenantLogo(params));
  return {
    // state of Analytics
    isLoggedIn,
    user,
    AccessToken,
    Loginshow,
    tenantLogo,
    // action of Analytics
    loginAction,
    logoutAction,
    reCaptchaVarifyAction,
    getTenantLogoAction
  };
}
export default useAuthStore;
